module.exports = __webpack_public_path__ + "static/media/XXh.6a4e60dc.png";